<template>
<div class="remixer">
  <button @click="vs = !vs">fs</button>
  <div v-if="vs">
    啟用反光板 <br />
    1<input type="checkbox" v-model="RS.visible1">
    2<input type="checkbox" v-model="RS.visible2">
    3<input type="checkbox" v-model="RS.visible3">
    4<input type="checkbox" v-model="RS.visible4">
    5<input type="checkbox" v-model="RS.visible5">
    6<input type="checkbox" v-model="RS.visible6">
    7<input type="checkbox" v-model="RS.visible7">
    <br />
    預覽反光板 <br />
    1<input type="checkbox" v-model="RS.afterVisible1">
    2<input type="checkbox" v-model="RS.afterVisible2">
    3<input type="checkbox" v-model="RS.afterVisible3">
    4<input type="checkbox" v-model="RS.afterVisible4">
    5<input type="checkbox" v-model="RS.afterVisible5">
    6<input type="checkbox" v-model="RS.afterVisible6">
    7<input type="checkbox" v-model="RS.afterVisible7">
    <br />
    1
    <input type="color" v-model="RS.color1">
    <input type="text" v-model="RS.color1">
    <input type="text" v-model="RS.opacity1">
    <input type="file" @change="updatedFile">
    <br />
    2
    <input type="color" v-model="RS.color2">
    <input type="text" v-model="RS.color2">
    <input type="text" v-model="RS.opacity2">
    <input type="file" @change="updatedFile2">
    <br />
    3
    <input type="color" v-model="RS.color3">
    <input type="text" v-model="RS.color3">
    <input type="text" v-model="RS.opacity3">
    <input type="file" @change="updatedFile3">
    <br />
    4
    <input type="color" v-model="RS.color4">
    <input type="text" v-model="RS.color4">
    <input type="text" v-model="RS.opacity4">
    <input type="file" @change="updatedFile4">
    <br />
    5
    <input type="color" v-model="RS.color5">
    <input type="text" v-model="RS.color5">
    <input type="text" v-model="RS.opacity5">
    <input type="file" @change="updatedFile5">
    <br />
    6
    <input type="color" v-model="RS.color6">
    <input type="text" v-model="RS.color6">
    <input type="text" v-model="RS.opacity6">
    <input type="file" @change="updatedFile6">
    <br />
    7
    <input type="color" v-model="RS.color7">
    <input type="text" v-model="RS.color7">
    <input type="text" v-model="RS.opacity7">
    <input type="file" @change="updatedFile7">
    <br />
    <br />
    Bloom:
    <br />
    <!-- exposure
    <input type="number" step="0.01" v-model="RS.bloom.exposure">
    <br/> -->

    threshold
    <input type="number" step="0.01" v-model="RS.bloom.threshold">
    <br/>

    strength
    <input type="number" step="0.01" v-model="RS.bloom.strength">
    <br/>

    radius
    <input type="number" step="0.01" v-model="RS.bloom.radius">
    <br/>

    <br />
    水晶Shader
    <br />
    <input type="file" @change="updatedFile">
    <br />
    View BG: <input type="checkbox" v-model="R.state.viewBG">
    <div v-if="val.canChange" :key="key" v-for="(val, key) in RS.uniforms">
      {{ key }}
      <input step="0.01" type="number" v-model="val.value">
    </div>
    <br />
    colorMultiply
    <input type="color" v-model="colorM">
    <input type="text" v-model="colorM">
    <br />
    colorAdd
    <input type="color" v-model="colorA">
    <input type="text" v-model="colorA">
    <br />
    colorSub
    <input type="color" v-model="colorS">
    <input type="text" v-model="colorS">
    <br />
    <!-- Use DUDV shift texture
    <input type="checkbox" v-if="RS.uniforms.useDudv" v-model="RS.uniforms.useDudv.value"> -->
  </div>


  <!-- <pre v-if="RS.uniforms">{{ RS.uniforms }}</pre> -->
</div>
</template>

<script>
import * as THREE from 'three'
import * as Remixer from './remixer.js'
export default {
  data () {
    return {
      vs: true,
      R: Remixer,
      RS: Remixer.state,
      colorM: '#ffffff',
      colorA: '#000000',
      colorS: '#000000'
    }
  },
  watch: {
    colorM () {
      this.updateColors()
    },
    colorA () {
      this.updateColors()
    },
    colorS () {
      this.updateColors()
    },
    colorMultiply () {
      this.$nextTick(() => {
        this.colorM = '#' + this.RS.uniforms.colorMultiply.value.getHexString()
        this.colorA = '#' + this.RS.uniforms.colorAdd.value.getHexString()
        this.colorS = '#' + this.RS.uniforms.colorSub.value.getHexString()
      })
    }
  },
  computed: {
    colorMultiply () {
      return this.RS.uniforms.colorMultiply
    }
  },
  methods: {
    updateColors () {
      try {
        this.RS.uniforms.colorMultiply.value = new THREE.Color(this.colorM)
        this.RS.uniforms.colorAdd.value = new THREE.Color(this.colorA)
        this.RS.uniforms.colorSub.value = new THREE.Color(this.colorS)
      } catch (e) {

      }
    },
    updatedFileCore (evt, cb) {
      let file = evt.target.files[0]
      if (file) {
        var reader = new FileReader()
        reader.onload = () => {
          cb(reader.result)
        }
        reader.readAsDataURL(file)
      }
    },
    updatedFile (evt) {
      console.log(evt.target)
      this.updatedFileCore(evt, (result) => {
        Remixer.state.texture = result
      })
    },
    updatedFile2 (evt) {
      console.log(evt.target)
      this.updatedFileCore(evt, (result) => {
        Remixer.state.texture2 = result
      })
    },
    updatedFile3 (evt) {
      console.log(evt.target)
      this.updatedFileCore(evt, (result) => {
        Remixer.state.texture3 = result
      })
    },
    updatedFile4 (evt) {
      console.log(evt.target)
      this.updatedFileCore(evt, (result) => {
        Remixer.state.texture4 = result
      })
    },
    updatedFile5 (evt) {
      console.log(evt.target)
      this.updatedFileCore(evt, (result) => {
        Remixer.state.texture5 = result
      })
    },
    updatedFile6 (evt) {
      console.log(evt.target)
      this.updatedFileCore(evt, (result) => {
        Remixer.state.texture6 = result
      })
    },
    updatedFile7 (evt) {
      console.log(evt.target)
      this.updatedFileCore(evt, (result) => {
        Remixer.state.texture7 = result
      })
    }
  }
}
</script>

<style scoped>
.remixer{
  color: white;
  font-size: 19px;
}
input[type="text"]{
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/KeyRemixer/KeyRemixer.vue